// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoText_root__1e25m"};